<div class="row">


    <div class="col-md-4">
        <img [src]="imgPrefix+movieDetails.poster_path" class="img-fluid" alt="">   
     </div>

     <div class="col-md-8">
         <h2 class="m-2">{{movieDetails.title}}{{movieDetails.name}}</h2>
         <p class="m-2 secondFontColor">{{movieDetails.tagline}}</p>

         <span class="bg-info p-1 rounded mx-2" *ngFor="let gen of movieDetails.genres">{{gen.name}}</span>

         <p class="my-2 lead secondFontColor">{{movieDetails.overview}}</p>
     </div>
</div>